import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const sid = m[1];
    (async () => {
      try {
        await api.post("/auth/google-session", null, { headers: { "X-Session-ID": sid } });
        await refresh();
      } catch {}
      window.history.replaceState({}, "", "/account");
      nav("/account", { replace: true });
    })();
  }, [nav, refresh]);
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="text-sm text-neutral-500">Signing you in…</p>
    </div>
  );
}
